/** Wraps a partner-portal page area: denies staff with 'none', makes 'view' read-only. */
import { ReactNode } from 'react';
import { Loader2, ShieldOff } from 'lucide-react';
import { usePortalAccess, type PortalKey } from '@/shared/hooks/usePortalAccess';
import { ReadOnlyScope } from '@/shared/ui/ReadOnlyScope';

export function PortalAccessGate({ portal, children }: { portal: PortalKey; children: ReactNode }) {
  const { data, isLoading } = usePortalAccess(portal);
  if (isLoading) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (data?.kind === 'staff' && data.level === 'none') {
    return (
      <div className="flex flex-col items-center gap-3 py-20 text-center">
        <ShieldOff className="h-10 w-10 text-destructive" />
        <h1 className="text-lg font-semibold text-foreground">No access to this portal</h1>
      </div>
    );
  }
  if (data?.kind === 'staff' && data.level === 'view') return <ReadOnlyScope>{children}</ReadOnlyScope>;
  return <>{children}</>;
}
